var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('contacUs'),_c('st-header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.getRouter),expression:"!getRouter"}]}),_c('breadcrumb',{staticClass:"breadcrumb-container"}),_c('app-main'),(_vm.getRouterFooter)?_c('StFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }